import React from 'react';

/**
 * AAStamp — circular rotating "AA+ Qualität" badge as hero flourish.
 * Uses SVG textPath for perfect circular text.
 */
const AAStamp = ({ size = 140, className = '' }) => {
  const r = size / 2 - 12;
  const cx = size / 2;
  const cy = size / 2;
  return (
    <div className={`relative ${className}`} style={{ width: size, height: size }}>
      <div className="absolute inset-0 rounded-full bg-brand-blueDark shadow-2xl shadow-brand-blue/40"></div>
      <svg viewBox={`0 0 ${size} ${size}`} className="absolute inset-0 aa-stamp">
        <defs>
          <path
            id="aa-circle"
            d={`M ${cx},${cy} m -${r},0 a ${r},${r} 0 1,1 ${r * 2},0 a ${r},${r} 0 1,1 -${r * 2},0`}
          />
        </defs>
        <text fill="#DCE8F7" fontSize="10" fontWeight="700" letterSpacing="4">
          <textPath href="#aa-circle" startOffset="0">
            FRACHIGERS HANDWERK · AA+ QUALITÄT · SEIT 20 JAHREN ·
          </textPath>
        </text>
      </svg>
      <div className="absolute inset-0 flex items-center justify-center flex-col text-white">
        <span className="font-display text-3xl leading-none">AA+</span>
        <span className="text-[9px] uppercase tracking-[0.2em] mt-1 text-white/80">Qualität</span>
      </div>
    </div>
  );
};

export default AAStamp;
